<template>
  <div class="bank-data-query">
    <div class="title">
      <h2>银行数据查询</h2>
    </div>

    <div class="query-form">
      <el-form :model="formData" :rules="rules" ref="formRef" label-width="150px">
        <!-- 企业信息 -->
        <el-form-item label="企业名称" prop="enterpriseName">
          <el-input 
            v-model="formData.enterpriseName" 
            placeholder="请输入企业名称" 
            clearable 
            @input="validateRelatedField('enterpriseName')"
          />
        </el-form-item>

        <el-form-item label="统一社会信用代码" prop="creditCode">
          <el-input 
            v-model="formData.creditCode" 
            placeholder="请输入统一社会信用代码" 
            clearable 
            @input="validateRelatedField('creditCode')"
          />
        </el-form-item>

        <!-- 个人信息 -->
        <el-form-item label="法人/农户姓名" prop="personName">
          <el-input 
            v-model="formData.personName" 
            placeholder="请输入法人或农户姓名" 
            clearable 
            @input="validateRelatedField('personName')"
          />
        </el-form-item>

        <el-form-item label="法人/农户身份证号" prop="idCardNumber">
          <el-input
            v-model="formData.idCardNumber"
            placeholder="请输入法人或农户身份证号"
            clearable
            @input="validateRelatedField('idCardNumber')"
          />
        </el-form-item>

        <!-- 资金用途 -->
        <!-- <el-form-item label="资金用途" prop="fundPurpose">
          <el-input
            v-model="formData.fundPurpose"
            placeholder="请输入资金用途"
            type="textarea"
            :rows="3"
          />
        </el-form-item> -->

        <!-- 查询按钮 -->
        <el-form-item>
          <div class="button-group">
            <el-button type="primary" @click="handleQuery" size="large">查询</el-button>
            <el-button @click="handleReset" size="large">重置</el-button>
          </div>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { getBankDetailViewInfo } from '@/api/RuralFinance'
export default {
  name: 'BankDataQuery',
  data() {
    return {
      detailInfo: {},
      formData: {
        enterpriseName: '',
        creditCode: '',
        personName: '',
        idCardNumber: '',
        fundPurpose: ''
      },
      rules: {
        enterpriseName: [
          {
            validator: (rule, value, callback) => {
              if (this.formData.creditCode && !value) {
                callback(new Error('请输入企业名称'))
              } else if (value && !this.formData.creditCode) {
                // 不在这里显示错误，让creditCode字段显示
                callback()
              } else {
                callback()
              }
            },
            trigger: ['blur', 'change']
          }
        ],
        creditCode: [
          {
            validator: (rule, value, callback) => {
              if (this.formData.enterpriseName && !value) {
                callback(new Error('请输入社会信用代码'))
              } else if (value && !this.formData.enterpriseName) {
                // 不在这里显示错误，让enterpriseName字段显示
                callback()
              } else if (value && !/^[A-Za-z0-9]{18}$/.test(value)) {
                callback(new Error('统一社会信用代码格式不正确'))
              } else {
                callback()
              }
            },
            trigger: ['blur', 'change']
          }
        ],
        personName: [
          {
            validator: (rule, value, callback) => {
              if (this.formData.idCardNumber && !value) {
                callback(new Error('请输入法人姓名'))
              } else if (value && !this.formData.idCardNumber) {
                // 不在这里显示错误，让idCardNumber字段显示
                callback()
              } else {
                callback()
              }
            },
            trigger: ['blur', 'change']
          }
        ],
        idCardNumber: [
          {
            validator: (rule, value, callback) => {
              if (this.formData.personName && !value) {
                callback(new Error('请输入身份证号码'))
              } else if (value && !this.formData.personName) {
                // 不在这里显示错误，让personName字段显示
                callback()
              } else if (
                value &&
                !/^[1-9]\d{5}(18|19|20)\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}[\dXx]$/.test(
                  value
                )
              ) {
                callback(new Error('身份证号码格式不正确'))
              } else {
                callback()
              }
            },
            trigger: ['blur', 'change']
          }
        ],
        // fundPurpose: [
        //   {
        //     required: true,
        //     message: '请输入资金用途',
        //     trigger: 'blur'
        //   }
        // ]
      }
    }
  },
  methods: {
    // 手动触发关联字段验证
    validateRelatedField(fieldName) {
      this.$nextTick(() => {
        if (fieldName === 'enterpriseName' && this.formData.enterpriseName) {
          this.$refs.formRef.validateField('creditCode')
        } else if (fieldName === 'creditCode' && this.formData.creditCode) {
          this.$refs.formRef.validateField('enterpriseName')
        } else if (fieldName === 'personName' && this.formData.personName) {
          this.$refs.formRef.validateField('idCardNumber')
        } else if (fieldName === 'idCardNumber' && this.formData.idCardNumber) {
          this.$refs.formRef.validateField('personName')
        }
      })
    },

    handleQuery() {
      // 先进行常规表单验证
      this.$refs.formRef.validate(async valid => {
        if (valid) {
          // 综合验证：确保企业信息和个人信息至少填写一组
          const hasEnterpriseInfo = this.formData.enterpriseName && this.formData.creditCode
          const hasPersonInfo = this.formData.personName && this.formData.idCardNumber

          if (!hasEnterpriseInfo && !hasPersonInfo) {
            this.$message.error('请至少填写企业信息或个人信息中的一组')
            return
          }

          let res = await getBankDetailViewInfo({
            companyName: this.formData.enterpriseName,
            socialCreditCode: this.formData.creditCode,
            bossName: this.formData.personName,
            userName: this.formData.personName,
            idCardNo: this.formData.idCardNumber,
            // fundPurpose: this.formData.fundPurpose
          })
          if (res.code === 0) {
            this.$message.success('查询成功')
            this.detailInfo = res.data || {}
            // 验证通过，跳转到贷款详情页面
            this.$router.push({
              path: '/memberCenter/financalService/financeLoanApplicationManagement/detailView',
              query: {
                detailInfo: JSON.stringify(this.detailInfo)
              }
            })
          } else {
            this.$message.error(res.msg || '查询失败')
          }
        } else {
          this.$message.error('请完善表单信息')
        }
      })
    },

    handleReset() {
      this.$refs.formRef.resetFields()
    }
  }
}
</script>

<style lang="less" scoped>
// 页面容器样式
.bank-data-query {
  padding: 30px;
  background: #fff;
  border-radius: 8px;
  // box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  transition: box-shadow 0.3s ease;

  // &:hover {
  // box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  // }
}

// 标题样式
.title {
  margin-bottom: 30px;
  text-align: center;
  position: relative;
  padding-bottom: 15px;

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 80px;
    height: 3px;
    background: linear-gradient(90deg, #409eff, #67c23a);
    border-radius: 1.5px;
  }

  h2 {
    color: #333;
    font-size: 24px;
    margin: 0;
    font-weight: 600;
  }
}

// 表单样式
.query-form {
  max-width: 800px;
  margin: 0 auto;

  .el-form-item {
    margin-bottom: 25px;
    position: relative;
  }

  // 表单标签样式
  .el-form-item__label {
    font-size: 14px;
    font-weight: 500;
    color: #606266;
    transition: color 0.2s;

    &:hover {
      color: #409eff;
    }
  }

  // 输入框样式
  .el-input {
    width: 100%;
    transition: all 0.2s;

    &:focus-within {
      transform: translateX(2px);
    }

    .el-input__inner {
      height: 42px;
      border-radius: 6px;
      border: 1px solid #dcdfe6;
      transition: all 0.2s;
      font-size: 14px;
      padding: 0 15px;

      &:focus {
        border-color: #409eff;
        box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
      }

      &:hover {
        border-color: #c0c4cc;
      }
    }
  }

  // 多行文本框样式
  .el-textarea {
    .el-textarea__inner {
      border-radius: 6px;
      border: 1px solid #dcdfe6;
      transition: all 0.2s;
      font-size: 14px;

      &:focus {
        border-color: #409eff;
        box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
      }
    }
  }

  // 错误提示样式
  .el-form-item__error {
    left: 120px;
    font-size: 12px;
  }

  // 按钮区域样式
  .button-group {
    display: flex;
    justify-content: center;
    gap: 20px;
    margin-top: 30px;
  }
}

// 按钮样式
.el-button {
  border-radius: 6px;
  transition: all 0.2s;

  &--primary {
    background-color: #409eff;
    border-color: #409eff;

    &:hover {
      background-color: #66b1ff;
      border-color: #66b1ff;
      transform: translateY(-1px);
      box-shadow: 0 2px 12px rgba(64, 158, 255, 0.4);
    }
  }

  &--default {
    &:hover {
      transform: translateY(-1px);
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    }
  }

  &--large {
    padding: 12px 32px;
    font-size: 16px;
    font-weight: 500;
  }
}

// 响应式设计
@media (max-width: 768px) {
  .bank-data-query {
    padding: 20px;
  }

  .title h2 {
    font-size: 20px;
  }

  .query-form {
    .el-form-item {
      margin-bottom: 20px;
    }

    .el-form-item__label {
      width: 100px;
      font-size: 13px;
    }

    .el-form-item__error {
      left: 100px;
    }
  }

  .el-button--large {
    padding: 10px 24px;
    font-size: 14px;
  }
}

@media (max-width: 480px) {
  .bank-data-query {
    padding: 15px;
    border-radius: 6px;
  }

  .query-form {
    .el-form {
      label-width: 90px;
    }

    .el-form-item__label {
      width: 90px;
      font-size: 12px;
    }

    .el-input__inner {
      height: 38px;
      font-size: 13px;
    }
  }

  .button-group {
    flex-direction: column;
    gap: 15px;
  }
}
</style>
